// Third-party
import React from 'react';

// Components
import { HoldingIcon } from '../../common';
import GenericLegend from '../GenericLegend';
import { LineChartDatum } from '../LineChart';

type Props = {
  data: LineChartDatum[];
};

const formatData = (data: LineChartDatum[]) => {
  if (!data || data.length === 0) {
    return [];
  }

  // Filter any scenarios from legend
  return Object.values(data)
    .filter(serie => serie.dashStyle !== 'Dash')
    .map(serie => ({
      type: serie.itemType,
      color: serie.color,
      name: serie.name,
      hideFromLegend: serie.hideFromLegend,
    }));
};

const IncomeLegend = ({ data }: Props) => {
  const formattedData = formatData(data);

  if (!formattedData.length) {
    return null;
  }

  const legendItems = formattedData
    .filter(datum => !datum.hideFromLegend)
    .map(datum => ({
      getLabel: () => (
        <div className="item-label">
          <HoldingIcon type={datum.type} color={datum.color} />
          <span className="legend-item-name" data-private data-dd-privacy="mask">
            {datum.name}
          </span>
        </div>
      ),
    }));

  return <GenericLegend items={legendItems} />;
};

export default IncomeLegend;
